import { cn } from '@mntn-dev/ui-utilities'
import { generateRandomNumber, makeRange } from '@mntn-dev/utilities'

import { Stack } from '../stack/stack.tsx'
import { SkeletonText } from './skeleton-text.tsx'
import { type SkeletonTextSize, skeletonLineGapMap } from './types.ts'

type SkeletonParagraphProps = {
  className?: string
  textSize?: SkeletonTextSize
  lines: number
}

const SkeletonParagraph = ({
  className,
  textSize = 'base',
  lines,
}: SkeletonParagraphProps) => {
  return (
    <div
      className={cn('w-full', {
        className,
      })}
    >
      <Stack direction="col" className={skeletonLineGapMap[textSize]}>
        {makeRange(lines - 1).map((i) => (
          <SkeletonText
            key={`line-${i}`}
            textSize={textSize}
            style={{ width: `${generateRandomNumber(90, 100)}%` }}
            className="w-full"
          />
        ))}
        <SkeletonText textSize={textSize} className="w-1/2" />
      </Stack>
    </div>
  )
}

export { SkeletonParagraph, type SkeletonParagraphProps }
